import React from 'react'
import Structure from '../components/layout/Structure'
import GameDetails from '../components/Portfolio/GameDetailsPage'

const PortfolioDetails = () => {
  return (
    <Structure>
      <GameDetails/>
    </Structure>
  )
}

export default PortfolioDetails